import { render, staticRenderFns } from "./UmfPlotly.vue?vue&type=template&id=79461053&"
import script from "./UmfPlotly.vue?vue&type=script&lang=js&"
export * from "./UmfPlotly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports